'use client';

import { Tab } from '@headlessui/react';
import React, { Fragment } from 'react';

import DefaultTabButton from '@/components/DefaultTabButton';

type InfoTabItemProps = {
    tabName: string;
    href?: string;
};

export default function InfoTabItem(props: InfoTabItemProps): React.JSX.Element {
    const { tabName, href } = props;

    const button = (selected: boolean) => (
        <DefaultTabButton
            className="px-24 lg:px-64"
            label={tabName}
            selected={selected}
        />
    );

    return href ? (
        <a
            href={href}
            rel="noreferrer">
            {button(false)}
        </a>
    ) : (
        <Tab as={Fragment}>{({ selected }) => button(selected)}</Tab>
    );
}
